export interface Route {
  path: string;
  render: () => string;
  onMount?: () => void;
}

let routes: Route[] = [];

export function registerRoutes(routeList: Route[]): void {
  routes = routeList;
}

export function navigate(path: string): void {
  window.location.hash = path;
}

export function getHash(): string {
  return window.location.hash || "#/login";
}

export function startRouter(): void {
  window.addEventListener("hashchange", handleRoute);
  handleRoute();
}

function handleRoute(): void {
  const hash = getHash();
  const path = hash.startsWith("#") ? hash.substring(1) : hash;

  const route = routes.find((r) => r.path === path);
  if (!route) return;

  const app = document.getElementById("admin-app");
  if (app) {
    app.innerHTML = route.render();
    if (route.onMount) {
      route.onMount();
    }
  }
}

export function refreshRoute(): void {
  handleRoute();
}
